import React, { createContext, useContext, useState } from "react";
import { offer } from "../data/salesCopy";
type PlanContextValue = {
  selectedId: string;
  setSelectedId: (id: string) => void;
};
const defaultId = offer.plans.find(p => p.featured)?.id ?? offer.plans[0].id;
const PlanContext = createContext<PlanContextValue>({
  selectedId: defaultId,
  setSelectedId: () => {}
});
export function PlanProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [selectedId, setSelectedId] = useState(defaultId);
  return <PlanContext.Provider value={{
    selectedId,
    setSelectedId
  }} data-id="element-332" data-mp="vn5wmp1cimvb">{children}</PlanContext.Provider>;
}
export function usePlan() {
  return useContext(PlanContext);
}